/**
 * Login.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Card, PageWrap } from '@minerva-analytics/pantheon';

import CardHeader from 'components/CardHeader';
import CardBody from 'components/CardBody';

import LoginForm from '../../components/LoginForm';

import userActions from '../../store/user/actions';
/**
 * A dedicated Login page so people can be redirected here
 *
 */
export class Login extends Component {
  static propTypes = {
    facebookLogin: PropTypes.func.isRequired,
    gmailLogin: PropTypes.func.isRequired,
    jwt: PropTypes.string,
    history: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    const { jwt, history } = this.props;

    // If you are logged in, then you should not be here
    if (jwt) {
      history.replace(`/`);
    }
  }

  signIn = (signInFunc) => {
    const {
      history,
    } = this.props;

    signInFunc(`login-page`);
    history.push(`/`);
  }


  render() {
    const {
      facebookLogin,
      gmailLogin,
    } = this.props;

    return (
      <PageWrap>
        <Card size="medium">
          <CardHeader>
            Login for More Trivia!
          </CardHeader>
          <CardBody>
            <h2>
              QuizHive is more than trivia!
            </h2>
            <LoginForm
              facebookLogin={ () => this.signIn(facebookLogin) }
              gmailLogin={ () => this.signIn(gmailLogin) }
              headlineText="Sign Up To See How You Perform Against Fellow Users!"
            />
          </CardBody>
        </Card>
      </PageWrap>
    );
  }
}

export default connect((state) => {
  return {
    jwt: state.user.JWT,
  };
}, {
  facebookLogin: userActions.facebookLogin,
  gmailLogin: userActions.gmailLogin,
})(Login);
